import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpCircleIconComponent from './adpCircleIcon.component';

let adpCircleIconModule = angular.module('adpCircleIcon', [
  uiRouter
])

.component('adpCircleIcon', adpCircleIconComponent)

.name;

export default adpCircleIconModule;



// WEBPACK FOOTER //
// ./src/app/components/adpCircleIcon/adpCircleIcon.js